import { FC, useContext } from "react";

import { Logo } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading, Paragraph } from "capitalrx-components-2.0/lib/typography";

import { PROVIDER_MANAGEMENT_LAYOUT } from "@/constants";
import { ThemeSelectorContext } from "@/context";
import judiHealth from "@/static/logos/judi-health-horizontal.png";

import styles from "./Footer.module.scss";

export const Footer: FC = () => {
  const { clientDisplayName, primary_color } = useContext(ThemeSelectorContext);
  const { isCompressed } = useResponsive(PROVIDER_MANAGEMENT_LAYOUT);
  const showFooter = clientDisplayName === "Judi Health" && !isCompressed;

  return (
    <>
      {showFooter && (
        <Stack alignment="center" className={styles.FooterContainer}>
          <Shelf spacing="small">
            <img src={judiHealth} style={{ height: "24px", width: "135px" }}/>
            <Heading style={{ color: primary_color, paddingBottom: "4px" }}>|</Heading>
            <Logo name="caprx-horizontal" style={{ height: "24px", width: "105px" }} />
          </Shelf>
          <Paragraph>
            <Body>&copy; 2025 Capital Rx, Inc., Judi Health, LLC, Amino, LLC All Rights Reserved.</Body>
          </Paragraph>
        </Stack>
      )}
    </>
  );
};
